import { render, staticRenderFns } from "./CustomRules.vue?vue&type=template&id=d8e75864&"
import script from "./CustomRules.vue?vue&type=script&lang=js&"
export * from "./CustomRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports